import React, { useEffect, useState, useCallback } from 'react';
import { Appointment } from '../dashboard/widgets/types/appointment';
import { appointmentRemindersService } from '../../services/appointment-reminders.service';
import AppointmentReminder from './AppointmentReminder';

interface AppointmentReminderProviderProps {
  children: React.ReactNode;
}

const AppointmentReminderProvider: React.FC<AppointmentReminderProviderProps> = ({ children }) => {
  const [activeReminder, setActiveReminder] = useState<Appointment | null>(null);

  // Handle reminder trigger
  const handleReminderTrigger = useCallback((appointment: Appointment) => {
    console.log('🔔 Zeige Erinnerung für:', appointment.title);
    setActiveReminder(appointment);

    // Also show browser notification as backup
    appointmentRemindersService.showBrowserNotification(appointment);

    // Play sound (optional)
    playNotificationSound();
  }, []);

  // Initialize reminders service
  useEffect(() => {
    // Set the callback
    appointmentRemindersService.setReminderCallback(handleReminderTrigger);

    // Request notification permission
    appointmentRemindersService.requestNotificationPermission();

    // Erinnerungen beim Start aus der API laden und alle 15 Minuten
    // auffrischen (falls Kollegen Termine anlegen/ändern)
    appointmentRemindersService.rescheduleAllFromStorage();
    const refreshInterval = setInterval(() => {
      appointmentRemindersService.rescheduleAllFromStorage();
    }, 15 * 60 * 1000);

    // Cleanup
    return () => {
      clearInterval(refreshInterval);
      appointmentRemindersService.clearAllReminders();
    };
  }, [handleReminderTrigger]);

  const handleClose = () => {
    setActiveReminder(null);
  };

  const handleSnooze = (minutes: number) => {
    if (activeReminder) {
      appointmentRemindersService.snoozeReminder(activeReminder.id, minutes);
      setActiveReminder(null);
    }
  };

  const playNotificationSound = () => {
    // Create a simple notification sound using Web Audio API
    try {
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.frequency.value = 800;
      oscillator.type = 'sine';

      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
    } catch (error) {
      console.warn('Konnte Benachrichtigungston nicht abspielen:', error);
    }
  };

  return (
    <>
      {children}
      {activeReminder && (
        <AppointmentReminder
          appointment={activeReminder}
          onClose={handleClose}
          onSnooze={handleSnooze}
        />
      )}
    </>
  );
};

export default AppointmentReminderProvider;
